import { FilterConfig, PanelTab } from "@/shared/types";
import { FilterType } from "@/shared/enums/Filter.enum";

const filters: FilterConfig[] = [
	{
		id: "name",
		name: "name",
		description: "filter_by_name",
		items: [],
	},
	{
		id: "status",
		name: "status",
		description: "filter_by_status",
		items: [
			{ id: "Active", label: "active" },
			{ id: "Inactive", label: "inactive" },
		],
	},
	{
		id: "keywords",
		name: "keywords",
		description: "filter_by_keywords",
		placeholder: "enter_keywords",
		items: [],
		type: FilterType.INPUT,
	},
];

const panels: PanelTab[] = [
	{
		title: "all_dhcs",
	},
];

const dhcColumns: string[] = [
	"name",
	"budget",
	"actual",
	"revenue",
	"totalNewClients",
	"clientTrend",
	"ownSale",
	"clients",
	"churn",
];

export { dhcColumns, panels, filters };
